import React, { useEffect, useCallback, useState} from 'react';
import {duplicateSteps} from 'pattern/utils/duplicateSteps.js';
import Documented from "components/help/Documented.js";
import {
    PADS_LENGTH_BUTTON,
}from "constants/contextual-help.js";
import {useWindowClearer} from "components/sidebar/useWindowClearer.js"
import {connect} from 'react-redux';

const PadLength = ({pad}) => { 
    let [changed, setChanged] = useState(1);
    let [opened, setOpened] = useState(false);
    let length = Math.max(
        ... pad.tracks.filter(x=>x)
            .map(x => x.pattern.length()));
    if (length === -Infinity) {
        length = 32;
    }
    let bars = length / 32.0;

    useWindowClearer({clear: () => setOpened(false), selected: opened});

    const halfLength = useCallback((e) => {
        e.stopPropagation();
        pad.tracks.filter(x => x)
            .forEach(t => t.halfTrackLength());
        setChanged(changed / 2);
    }, [pad, setChanged, changed]);

    const doubleLength = useCallback((e) => {
        e.stopPropagation();
        pad.tracks.filter(x => x)
            .forEach(t => duplicateSteps(t, undefined, pad.sequencerEngine.resolution));
        setChanged(changed * 2);
    }, [pad, setChanged, changed]);

    let opener = "";
    if (opened) {
        opener = (
            <div className="length-dropdown">
              <div onMouseDown={halfLength} className="length-btn">-</div>
              <div onMouseDown={doubleLength} className="length-btn">+</div>
            </div>
        );
    }
    return (
        <Documented
          element={PADS_LENGTH_BUTTON}
          className="pad-length">
          {opener}
          Length <span onMouseDown={() => setOpened(true)} className="bars">{bars}</span> bars</Documented>
    );
}

const mapStateToProps = (state, props) => {
  return {
      tracks: props.pad.tracks
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PadLength);
